import { render, staticRenderFns } from "./DisplayOrderInfo.vue?vue&type=template&id=73d5328e&"
import script from "./DisplayOrderInfo.vue?vue&type=script&lang=ts&"
export * from "./DisplayOrderInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports